import { FreeCamera } from "@babylonjs/core";
import type { ColyseusClient } from "../network/ColyseusClient.js";

export class LocalPlayer {
  private camera: FreeCamera;
  private network: ColyseusClient;
  private lastX: number = 0;
  private lastY: number = 0;
  private lastZ: number = 0;
  private lastRot: number = 0;
  private readonly moveThreshold: number = 0.02;
  private readonly sendIntervalMs: number = 50;
  private intervalHandle: ReturnType<typeof setInterval> | undefined;

  constructor(camera: FreeCamera, network: ColyseusClient) {
    this.camera = camera;
    this.network = network;
  }

  start(): void {
    this.intervalHandle = setInterval(() => this.tick(), this.sendIntervalMs);
  }

  stop(): void {
    if (this.intervalHandle !== undefined) {
      clearInterval(this.intervalHandle);
      this.intervalHandle = undefined;
    }
  }

  private tick(): void {
    const x: number = this.camera.position.x;
    // Feet height (camera eye height is 1.7 above the feet).
    const y: number = this.camera.position.y - 1.7;
    const z: number = this.camera.position.z;
    const rot: number = this.camera.rotation.y;
    if (
      Math.abs(x - this.lastX) < this.moveThreshold &&
      Math.abs(y - this.lastY) < this.moveThreshold &&
      Math.abs(z - this.lastZ) < this.moveThreshold &&
      Math.abs(rot - this.lastRot) < this.moveThreshold
    ) {
      return;
    }
    this.network.sendMove(x, y, z, rot);
    this.lastX = x;
    this.lastY = y;
    this.lastZ = z;
    this.lastRot = rot;
  }
}
